import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/useUserData";
import styles from "./UserComponent.module.css";
import { useAuth } from "../../contexts/useAuth";
import { useChat } from "../../contexts/useChatData";

export const UserComponent = () => {
    const {userName, pindi, salesMediaName, userDepartment, origin } = useUser();
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();

    function handleClick() {
        if (logout) {
            logout();
            navigate("/login");
        }
    }

    return (
        <>
            {origin?.includes("wcrctelco") || origin?.includes("t3") ? (
                <div className={styles.userModule}>
                    {userName && (
                        <div className={styles.userInfo}>
                            <div className={styles.userImage}></div>
                            <div className={styles.userNameContainer}>
                                <div className={styles.userName}>{pindi}</div>
                                <div className={styles.userName}>{salesMediaName}</div>
                            </div>
                            {!isAuthenticated && (
                                <button
                                    className={styles.buttonLogout}
                                    onClick={handleClick}
                                ></button>
                            )}
                        </div>
                    )}
                </div>
            ) : origin?.includes("wcrc") ? (
                <div className={styles.userModule}>
                    {userName && (
                        <div className={styles.userInfo}>
                            <div className={styles.userImage}></div>
                            <div className={styles.userNameContainer}>
                                <div className={styles.userName}>{userName}</div>
                                <div className={styles.userName}>{userDepartment}</div>
                            </div>
                            {!isAuthenticated && (
                                <button
                                    className={styles.buttonLogout}
                                    onClick={handleClick}
                                ></button>
                            )}
                        </div>
                    )}
                </div>
            ) : (
                <div className={styles.userModule}>
                {userName && (
                    <div className={styles.userInfo}>
                        <div className={styles.userImage}></div>
                        <div className={styles.userName}>{userName}</div>
                        {!isAuthenticated && (
                            <button
                                className={styles.buttonLogout}
                                onClick={handleClick}
                            ></button>
                        )}
                    </div>
                )}
            </div>
            )}
        </>
        
    );
};

export default UserComponent;
